import React from 'react';
import "../style.css"
import Header from "../menu/Header";
import Menu from "../menu/Menu";
import EstateInfo from './EstateInfo';
import { userContext } from '../../../context/usercontext';
import { useContext, useEffect } from 'react';
import OwnerInfo from './OwnerInfo';
import ExpertInfo from './ExpertInfo';
import Factor from './Factor';

const ExpertRequest = () => {

    const {requestStep,setRequestStep} = useContext(userContext)

    useEffect(() => {
        const fetchData = async () => {
         setRequestStep(1)
        };
        fetchData();
      }, []);

    return (
        <div >
            <div >
             <div className='w-100'>
             {
                requestStep ===1 ? (
                    <EstateInfo/>
                ) : requestStep ===2 ? (
                    <OwnerInfo/>
                ) : requestStep === 3 ? (
                    <ExpertInfo/>
                ) : requestStep === 4 ? (
                    <Factor/>
                ) : ""
             }
             </div>
            </div>
        </div>
    );
};

export default ExpertRequest;
